// extracted by mini-css-extract-plugin
module.exports = {"select":"style_select__1u8S9"};